/* eslint-disable */
import 'promise-polyfill/src/polyfill'



// WEBPACK FOOTER //
// ./src/v1/client.polyfill.js